import { Col, Row } from "antd";
import { get } from "lodash";
import { useDispatch, useSelector } from "react-redux";

import s from '../../SecondaryCard.module.css';
import cardStyle from './GneLngLoadableSecondary.module.css';
import { useEffect } from "react";
import { fetchCargoDelivery } from "../../../../../action/actionScoreCard";

export default function GneLngLoadable() {
    const dispatch = useDispatch();

    const scoreCard = useSelector((state: any) => state.scoreCard);
  const { cargoDeliveryData } = scoreCard;


    useEffect(() => {
        dispatch(fetchCargoDelivery())
    },[])

    return (
        <div className={cardStyle.sectionContainer}>
            <div className={s.detailsItem}>
                <div className={cardStyle.sectionInfo}>
                    <div className={cardStyle.sectionTitle}>
                        <span>{cargoDeliveryData?.label}</span>
                    </div>
                    <div className={cardStyle.cargoValue}>
                        <span>{cargoDeliveryData?.value?.toLocaleString('en-US')}</span>
                        <span>&nbsp;{cargoDeliveryData?.unit}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}